import { atom, createStore } from 'jotai'
import { Tenant } from '@/payload-types'

export function createGlobalStore(initialTenant: Tenant | null) {
  const store = createStore()
  store.set(tenantAtom, initialTenant)
  return store
}

export const tenantAtom = atom<Tenant | null>()
